import company from '../themes/themes';

export const COMPANY_NAME = company[process.env.REACT_APP_THEME]?.company;
